<div class="arrow-steps clearfix">
  @for (step of steps; track step; let i = $index) {
    <div
      class="step"
      [ngClass]="{ current: i === currentStep, done: i < currentStep }"
    >
      <span>{{ step }}</span>
    </div>
  }
</div>
